import { APP } from '../../globals';
import {default as BaseUI} from '../../layout/LoaderUI';
import {bindEvent, unbindEvent} from '../../layout/helpers';
import {P2M_LOGO, HTML5_LOGO, PLAY_BUTTON_DISABLED, PLAY_BUTTON_ENABLED} from '../../layout/images';

class LoaderUI extends BaseUI {

    constructor(layout, loader) {
        super(layout, loader);

        this.button = null;
        this.logo = null;
        this.progressBar = null;
        this.html5Logo = null;

        this.skipPlayButton = false;

        this.createLayout();
        this.addListeners();
    }

    destructor() {
        if (this.container && this.button) {
            this.container.removeChild(this.button);
            unbindEvent(this.button, 'click', this.dispatchComplete);
            this.button = null;
        }
        super.destructor();
    }

    createLayout() {

        this.container.style.background = "#fff";

        this.logo = this.container.appendChild(document.createElement('img'));
        this.logo.src = P2M_LOGO;
        this.logo.style.position = 'absolute';
        this.logo.style.left = '50%';
        this.logo.style.top = '50%';

        //TODO: config?
        this.logo.style.cursor = "pointer";
        bindEvent(this.logo, 'click', this.openLogoLink);

        this.button = this.container.appendChild(document.createElement('img'));
        this.button.src = PLAY_BUTTON_DISABLED;
        this.button.style.position = 'absolute';
        this.button.style.left = '50%';
        this.button.style.top = '50%';

        this.progressBar = this.container.appendChild(document.createElement('div'));
        this.progressBar.style.position = 'absolute';
        this.progressBar.style.left = '50%';
        this.progressBar.style.top = '50%';
        this.progressBar.style.backgroundColor = '#fff';
        this.progressBar.style.border = '2px solid #e44d26';
        this.progressBar.style.padding = '1px';

        let p = this.progressBar.appendChild(document.createElement('div'));
        p.style.position = 'relative';
        p.style.height = '100%';
        p.style.width = '0';
        p.style.backgroundColor = '#e44d26';

        this.html5Logo = this.container.appendChild(document.createElement('img'));
        this.html5Logo.src = HTML5_LOGO;
        this.html5Logo.style.position = 'absolute';
        this.html5Logo.style.left = '50%';
        this.html5Logo.style.top = '50%';

        this.fitLayout();
    }

    disableLogoLink() {
        this.logo.style.cursor = "default";
        unbindEvent(this.logo, 'click', this.openLogoLink);
    }

    openLogoLink() {
        window.open("//playtomax.com", "_blank");
    }

    fitLayout() {

        var scale = APP.layout.scale * 2;

        let w = 0, h = 0;

        w = 300 * scale; h = 65 * scale;
        this.logo.style.width = w + 'px';
        this.logo.style.marginLeft = -w / 2 + 'px';
        this.logo.style.height = h + 'px';
        this.logo.style.marginTop = -h - 24 * scale + 'px';

        w = 65 * scale; h = 29 * scale;
        this.button.style.width = w + 'px';
        this.button.style.marginLeft = -w / 2 + 'px';
        this.button.style.height = h + 'px';
        this.button.style.marginTop = 30 * scale + 'px';

        w = 200 * scale; h = 12 * scale;
        this.progressBar.style.width = w + 'px';
        this.progressBar.style.marginLeft = -w / 2 + 'px';
        this.progressBar.style.height = h + 'px';
        this.progressBar.style.marginTop = -h / 2 - 12 * scale + 'px';
        this.progressBar.style.padding = scale + 'px';

        w = 30 * scale; h = 33 * scale;
        this.html5Logo.style.width = w + 'px';
        this.html5Logo.style.marginLeft = -w / 2 + 'px';
        this.html5Logo.style.height = h + 'px';
        this.html5Logo.style.marginTop = -h / 2 - 8 * scale + 'px';
    }

    hideLogo() {
        this.logo.style.visibility = "hidden";
    }

    hidePlayButton() {
        this.button.style.visibility = "hidden";
    }

    hideHtml5Logo() {
        this.html5Logo.style.visibility = "hidden";
    }

    showProgress(prc = 0) {
        this.progressBar.querySelector('div').style.width = ~~prc + '%';
    }

    showComplete() {
        this.showProgress(100);
        this.button.src = PLAY_BUTTON_ENABLED;
        this.button.style.cursor = 'pointer';

        if(this.skipPlayButton) {
            this.dispatchComplete();
            return;
        }

        bindEvent(this.button, 'click', () => {
            this.dispatchComplete();
        });
    }
}

export default LoaderUI;